import { logEvent } from './analyticsUtils';

const layersAnalytics = () => {

  const ANALYTICS_EVENTS = {
    LayerEnabled: 'enabled_layer',
    LayerDisabled: 'disabled_layer',

    LayerCategoryEnabled: 'enabled_layer_category',
    LayerCategoryDisabled: 'disabled_layer_category',

    LayerActiveDisabled: 'disabled_layer_active',
    LayerRecentEnabled: 'enabled_layer_recent',

    LayerOpacityChanged: 'changed_layer_opacity',

    LayerSearchUsed: 'used_layer_search',

    LayerRecentsCleared: 'cleared_layer_recents',

    LayerError: 'error_layer',
  };

  const logLayerEnabled = (stateName, categoryName, subCategoryName, layerName) => {
    logEvent(ANALYTICS_EVENTS.LayerEnabled, {
      layer_state: stateName,
      layer_category: categoryName,
      sub_category: subCategoryName,
      layer_name: layerName,
    });
  };

  const logLayerDisabled = (stateName, categoryName, subCategoryName, layerName) => {
    logEvent(ANALYTICS_EVENTS.LayerDisabled, {
      layer_state: stateName,
      layer_category: categoryName,
      sub_category: subCategoryName,
      layer_name: layerName,
    });
  };

  const logLayerCategoryEnabled = (stateName, categoryName) => {
    logEvent(ANALYTICS_EVENTS.LayerCategoryEnabled, {
      layer_state: stateName,
      layer_category: categoryName,
    });
  };

  const logLayerCategoryDisabled = (stateName, categoryName) => {
    logEvent(ANALYTICS_EVENTS.LayerCategoryDisabled, {
      layer_state: stateName,
      layer_category: categoryName,
    });
  };

  const logLayerActiveDisabled = (stateName, categoryName, subCategoryName, layerName) => {
    logEvent(ANALYTICS_EVENTS.LayerActiveDisabled, {
      layer_state: stateName,
      layer_category: categoryName,
      layer_subcategory: subCategoryName,
      layer_name: layerName
    });
  };

  const logLayerRecentEnabled = (stateName, categoryName, subCategoryName, layerName) => {
    logEvent(ANALYTICS_EVENTS.LayerRecentEnabled, {
      layer_state: stateName,
      layer_category: categoryName,
      layer_subcategory: subCategoryName,
      layer_name: layerName
    });
  };

  const logLayerOpacityChanged = (value, stateName, categoryName) => {
    logEvent(ANALYTICS_EVENTS.LayerOpacityChanged, {
      layer_opacity: value,
      layer_state: stateName,
      layer_category: categoryName,
    });
  };

  const logLayerSearchUsed = (stateName, categoryName) => {
    logEvent(ANALYTICS_EVENTS.LayerSearchUsed, {
      layer_state: stateName,
      layer_category: categoryName,
    });
  };

  const logLayerRecentsCleared = () => {
    logEvent(ANALYTICS_EVENTS.LayerRecentsCleared);
  };

  const logLayerError = (e, stateData, categoryData, subCatData, layer) => {
    logEvent(ANALYTICS_EVENTS.LayerError, {
      error: e.error,
      state: stateData.stateName,
      category: categoryData.categoryName,
      subCategory: subCatData ? subCatData.subCategoryName : null,
      layer_name: layer.name,
      layer_url: layer.layerUrl,
    });
  };

  return {
    logLayerEnabled,
    logLayerDisabled,

    logLayerCategoryEnabled,
    logLayerCategoryDisabled,

    logLayerActiveDisabled,
    logLayerRecentEnabled,

    logLayerOpacityChanged,

    logLayerSearchUsed,

    logLayerRecentsCleared,
  
    logLayerError,
  };
};

export default layersAnalytics();